import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { StyleSheet, View, ScrollView, Platform, Linking, Alert } from 'react-native';

import * as authActions from '../store/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import NavigateRow from '../components/NavigateRow';
import ShadowBox from '../components/ShadowBox';
import BaseText from '../components/BaseText';
import { GOOGLE_PACKAGE_NAME, APPLE_STORE_ID, CREW_ENABLED } from '../config/env';
import { CommonProperties, Color, CommonStyles } from '../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import { Screens } from '../constants/ScreenNames';
import { selectUserProfile } from '../store/selectors/profile.selector';
import { selectCompanyCurrency } from '../store/selectors/auth.selector';
import { getCurrencySymbol } from '../utils/currency.utils';

const SettingsScreen = ({ navigation }) => {
  const { tKey } = useComponentTKey('SettingsScreen');
  const { t } = useTranslation(i18nNS.settings);
  const companySupportDetails = useSelector(selectUserProfile);
  const dispatch = useDispatch();
  const onNotificationPress = () => {
    navigation.navigate(Screens.Notification);
  };
  const currency = useSelector(selectCompanyCurrency);
  const currencySymbol = getCurrencySymbol(currency)?.symbol;
  const onAboutPress = () => {
    navigation.navigate(Screens.About);
  };

  const onLegalPress = () => {
    navigation.navigate(Screens.Legal);
  };

  const onCurrencyPress = () => {};
  const onLogoutPress = () => {
    dispatch(authActions.logout());
  };
  const openEmail = () => {
    Linking.openURL(`mailto:${companySupportDetails?.SupportContactEmail}?subject=User Query`);
  };

  const startRating = () => {
    Alert.alert(
      t(tKey('RateUs')),
      t(tKey('RateUsMessage')),
      [
        { text: t(tKey('Sure')), onPress: () => openStore() },
        {
          text: t(tKey('NoThanks')),
          onPress: () => {},
          style: 'cancel',
        },
      ],
      { cancelable: false }
    );
  };

  const openStore = () => {
    if (Platform.OS !== 'ios') {
      Linking.openURL(`market://details?id=${GOOGLE_PACKAGE_NAME}`).catch(() =>
        Alert.alert(t(tKey('PlayStoreOpenFailure')))
      );
    } else {
      Linking.openURL(`itms://itunes.apple.com/in/app/apple-store/${APPLE_STORE_ID}`).catch(() =>
        Alert.alert(t(tKey('AppStoreOpenFailure')))
      );
    }
  };

  return (
    <View style={styles.wrap}>
      <ScrollView>
        <ShadowBox>
          {/* {!CREW_ENABLED && (
            <NavigateRow
              iconColor={Color.primary}
              text={t(tKey('Notifications'))}
              disableAnimation
              onPressCallback={onNotificationPress}
            />
          )} */}

          <NavigateRow
            iconColor={Color.primary}
            text={`Currency(${currencySymbol}${currency})`}
            hiddenRightIcon={true}
            onPressCallback={onCurrencyPress}
          />

          {Platform.OS != 'web' && !CREW_ENABLED && (
            <NavigateRow
              iconColor={Color.primary}
              text={t(tKey('RateUs'))}
              disableAnimation
              onPressCallback={startRating}
            />
          )}

          <NavigateRow
            iconColor={Color.primary}
            text={t(tKey('EmailUs'))}
            disableAnimation
            onPressCallback={openEmail}
          />

          {!CREW_ENABLED && (
            <NavigateRow
              iconColor={Color.primary}
              text={t(tKey('About'))}
              disableAnimation
              onPressCallback={onAboutPress}
            />
          )}

          <NavigateRow
            iconColor={Color.primary}
            text={t(tKey('Legal'))}
            disableAnimation
            onPressCallback={onLegalPress}
          />

          <NavigateRow
            iconColor={Color.primary}
            text={t(tKey('Logout'))}
            hiddenRightIcon="true"
            onPressCallback={onLogoutPress}
          />
        </ShadowBox>
        <View style={CommonStyles.pt3}>
          <BaseText style={styles.textStyle}>{t(tKey('CustomerService'))}:</BaseText>
          <BaseText style={styles.textStyle}>
            {companySupportDetails?.SupportContactNo} or{' '}
            {companySupportDetails?.SupportContactEmail}
          </BaseText>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: Color.accent,
    ...CommonProperties.pt3,
  },
  textStyle: {
    textAlign: 'center',
    ...CommonProperties.h3,
  },
});

export default SettingsScreen;
